import { Reveal, SectionHeader } from "@/components/shared";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data";

export function FAQ() {
  return (
    <section className="container-auvra py-24 md:py-32 lg:py-40" data-testid="faq">
      <SectionHeader chapter="09" kicker="FAQ" title="Frequently asked questions" center />
      <Reveal className="max-w-3xl mx-auto">
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-white/10 rounded-2xl mb-4 px-6 data-[state=open]:border-auvra-blue/40 data-[state=open]:bg-auvra-blue/[0.03] transition-colors"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left text-base md:text-lg font-medium hover:no-underline hover:text-auvra-blue py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-secondary-auvra leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
}

export function FinalCTA({ onGetStarted, onDemo }) {
  return (
    <section className="relative py-32 md:py-48 overflow-hidden" data-testid="final-cta">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] blue-glow pointer-events-none" />
      <div className="container-auvra relative z-10 text-center">
        <Reveal>
          <span className="font-display italic text-auvra-blue text-2xl md:text-3xl">Get started</span>
        </Reveal>
        <Reveal i={1}>
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-semibold tracking-tighter leading-[1.03] mt-4 max-w-4xl mx-auto">
            Ready to tokenize the next asset?
          </h2>
        </Reveal>
        <Reveal i={2}>
          <p className="text-secondary-auvra text-lg mt-8 max-w-xl mx-auto">
            Join the institutions building the future of real-world asset finance on AUVRA.
          </p>
        </Reveal>
        <Reveal i={3} className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-12">
          <button
            onClick={onGetStarted}
            data-testid="cta-get-started-btn"
            className="bg-auvra-blue hover:bg-auvra-blue/90 text-white font-medium px-8 py-4 rounded-full transition-all hover:shadow-[0_0_40px_rgba(37,99,235,0.5)]"
          >
            Get Started
          </button>
          <button
            onClick={onDemo}
            data-testid="cta-demo-btn"
            className="border border-white/15 hover:border-white/40 text-white font-medium px-8 py-4 rounded-full transition-all hover:bg-white/5"
          >
            Book Demo
          </button>
        </Reveal>
      </div>
    </section>
  );
}
